import React from 'react';
import FormSection from './FormSection';
import FormField from './FormField';

const AgentFields = [
	{ key: 'name', label: 'Template Name', type: 'text' },
	{ key: 'agent_type', label: 'Agent Type', type: 'select', options: ['gemini', 'openai'] },
	{ key: 'model', label: 'Model', type: 'select', options: ['gemini-2.5-flash-lite', 'gemini-2.5-flash', 'gpt-4o-mini', 'gpt-4o'] },
	{ key: 'temperature', label: 'Temperature (0-1)', type: 'number' },
];

function TemplateSettings({ agent_settings, on_change }) {
	return (
		<FormSection title="Template Settings">
			{AgentFields.map(function(field) {
				return (
					<FormField
						key={field.key}
						field={field}
						value={agent_settings[field.key]}
						on_change={on_change}
					/>
				);
			})}
		</FormSection>
	);
}

export default TemplateSettings;
